import { IAssunto } from './../modelo/Assunto';
import AssuntoApi from '../api/AssuntoApi';

class AssuntoService {


    async buscarPorProcessos(idsProcessos: number[], silent: boolean = false): Promise<IAssunto[][]> {
        const ids = [...idsProcessos];
        const pageSize = 900;
        const pages = new Array(Math.ceil(ids.length / pageSize)).fill(null).map(_x => ids.splice(0, pageSize));
        const result = await Promise.all(pages.map(page => AssuntoApi.buscarPorProcessos(page, silent)));
        let retorno = [];
        result.forEach(r => retorno = { ...retorno, ...r });
        return retorno;
    }
}

export default new AssuntoService();